import type { CSSProperties } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useToken } from '../../../../Flow/ConsentContextProvider';

const messages = defineMessages({
  title: {
    id: 'oauth.twg.heading',
    defaultMessage:
      '{clientName} is requesting access to your Atlassian account',
    description: 'Heading for TWG CLI Consent screen',
  },
});

const styles: Record<string, CSSProperties> = {
  heading: {
    color: 'var(--twg-heading)',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '28px',
    margin: 0,
    maxWidth: '312px',
  },
};

const Header = () => {
  const { clientName } = useToken();

  return (
    <h1 style={styles.heading}>
      <FormattedMessage {...messages.title} values={{ clientName }} />
    </h1>
  );
};

export default Header;
